export enum ModuleNameEnum {
  LOCATIONS = 'locations',
  SPACES = 'spaces',
  BOOKINGS = 'bookings',
  TRANSACTIONS = 'transactions',
  CLASSES = 'classes',
  CUSTOMERS = 'customers',
  AUTHENTICATION_ACL = 'authentication_acl',
  SETTINGS = 'settings',
  BANNERS = 'banners',
  CAMPAIGNS = 'campaigns',
}
